import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class TemporalPasswordService {

    private baseEndpoint;

    constructor(private httpClient: HttpClient) {
        this.baseEndpoint = environment.apiUser
    }

    changeTemporalPassword(body) {
        const url = `${this.baseEndpoint}/password/temporary/change`;
        return this.httpClient.post(url, body);
    }
}
